import { initSimpleTooltips, initContentTooltips } from "@plugins";
import jquery from "jquery";

const $ = jquery;

const tooltipOptions = {
    placement: "right",
};

$(document).ajaxSuccess(() => {
    initSimpleTooltips(".js-label-simple-tooltip-init", tooltipOptions);
    initContentTooltips(".js-label-tooltip-init");
});

window.addEventListener("load", () => {
    initSimpleTooltips(".js-label-simple-tooltip-init", tooltipOptions);
    initContentTooltips(".js-label-tooltip-init");
});
